export default "__VITE_ASSET__CE3HEQkJ__"